var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18961",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18961",
    transform: "translate(-14205 -478)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17430",
    "data-name": "\\u9577\\u65B9\\u5F62 17430",
    width: 45,
    height: 45,
    transform: "translate(14205 478)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_3",
    "data-name": "Layer 3",
    d: "M49.69,35.612a1.849,1.849,0,0,1,0,2.438l-.168.168-9.218,7.8a1.838,1.838,0,1,1-2.55-2.648l.168-.168,9.218-7.8a1.835,1.835,0,0,1,2.592.21Zm0-11.711a1.849,1.849,0,0,1,0,2.438l-.168.154-23.1,19.528a1.849,1.849,0,0,1-2.564-2.648l.168-.168L47.084,23.677a1.835,1.835,0,0,1,2.592.224Zm0-11.725a1.849,1.849,0,0,1,0,2.438l-.168.168L12.581,46.021a1.838,1.838,0,0,1-2.55-2.648l.168-.168,36.885-31.24a1.835,1.835,0,0,1,2.592.21Zm-13.841.014a1.849,1.849,0,0,1,0,2.438l-.168.168L12.581,34.31a1.849,1.849,0,0,1-2.55-2.662l.168-.154L33.244,11.966a1.863,1.863,0,0,1,2.606.224Zm-13.827,0a1.835,1.835,0,0,1,0,2.438l-.168.168-9.218,7.8a1.838,1.838,0,0,1-2.55-2.648l.168-.154,9.218-7.817a1.863,1.863,0,0,1,2.606.21Z",
    transform: "translate(14197.532 471.473)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundButton);
export default __webpack_public_path__ + "static/media/backgroundButton.83574a12f295d63c0adfeba546d40e21.svg";
export { ForwardRef as ReactComponent };